import { render } from "./TableShowForPop.vue?vue&type=template&id=a42bc6d2&scoped=true"
import script from "./TableShowForPop.vue?vue&type=script&lang=js"
export * from "./TableShowForPop.vue?vue&type=script&lang=js"

import "./TableShowForPop.vue?vue&type=style&index=0&id=a42bc6d2&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42bc6d2"]])

export default __exports__